import type { FaireProductEntity } from "../../entity_types/product";

export const p_4xe5h79nvx: FaireProductEntity = {
  token: "p_4xe5h79nvx",
  type: "product",
  name: "Merida Candle",
  brandToken: "b_c3hepkjc1t",
  brandName: "Nopalera",
  imageUrl:
    "https://cdn.faire.com/fastly/c3e78273bb628101c11e2f73659d329385985c1762bb6fc2472ffa088c4527d1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/65caaa4a620b41f82b4c2124c14fde28652e2ca8e08d9ec55d7c58a6783da273.jpeg",
    "https://cdn.faire.com/fastly/f16ec7328102327ed88d5cbfd7bc68407fd49932e1b35dc41fe5c54ccedbeb6b.jpeg",
    "https://cdn.faire.com/fastly/40b7ef9ddcc0b72c60ec622914c33c5acee4c241092c5b8ff7e36cb8635de321.jpeg",
  ],
  priceDollars: 25,
  description:
    "8.5 oz | 241 g\nBurn time: 60 hours\n\nMerida - Mexico’s Yucatan peninsula is a lush region that is home to thousands of ancient ceremonial water wells known as cenotes - the pueblo mágico of Merida is particularly known for these.  Merida refreshes your spirit with the scent of lush greens, warm limestone and dry amber that surround these natural wells. \n\nTOP: Cactus, Eucalyptus Essential Oil*, Bamboo\nMID:  White Jasmine, Parsley, Green Jasmine Stem\nBASE: Musk, Dry Amber, Cedarwood Essential Oil*\n\nBENEFITS\n • Non-toxic Luxury Fragrance\n • Phthalates Free | Paraffin Free | Palm Oil Free | Vegan\n • Coco-Soy Wax Blend\n • Organic Cotton Wick\n\nOur glass vessels were hand blown by artisans in Mexico City. Be sure to use them for your favorite Margarita or Paloma once you’ve burned through your candle.\n",
  tags: [],
  msrpDollars: 50,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:03:47.229Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
